import * as React from 'react'
import { IngestedItem } from 'components/ingestion/IngestedItem'
import { Ingested } from 'components/ingestion/Ingested'
import {
  ContentUploadIndex,
  PartnerContentUpload,
} from 'components/content_upload/ContentUpload'
import { Box, Button } from '@mui/material'
import { VersionMapping } from 'components/version_mapping/VersionMapping'
import { MappingFilterType } from 'components/version_mapping/utility'
import { WithTree } from 'components/tree/navigationHelpers/WithTree'
import { PresentationsTreeFix } from 'components/tree/masters/presentations/PresentationsFix'
import { useNavigateTo, useParams } from 'infrastructure/routing'
import { useGetTreeById } from 'reducers/trees_hooks'

export function IngestedItemFromRoute() {
  const { partnerKey, ingestionId } = useParams()
  if (!partnerKey || !ingestionId) {
    return null
  }
  return <IngestedItem partnerKey={partnerKey} ingestionId={ingestionId} />
}

export function IngestedFromRoute() {
  const { partnerKey } = useParams()
  if (!partnerKey) return null
  return <Ingested partnerKey={partnerKey} />
}

export function ContentUpload() {
  const navigate = useNavigateTo()
  const goToPartner = ({
    partner,
    currId,
    gradeCode,
  }: {
    partner: string
    currId: string
    gradeCode: string
  }) => {
    navigate(`/content_upload/${partner}/${currId}/${gradeCode}`)
  }
  return <ContentUploadIndex goToPartner={goToPartner} />
}

export function PartnerContentUploadWrapper() {
  const { partnerId, currId, gradeCode } = useParams()
  if (!partnerId || !currId || !gradeCode) {
    return null
  }
  return (
    <PartnerContentUpload
      partner={partnerId}
      subject={currId}
      gradeCode={gradeCode}
    />
  )
}

export function VersionMappingParams() {
  const [reviewFilters, setReviewFilters] =
    React.useState<MappingFilterType[]>()
  const [reviewIndex, setReviewIndex] = React.useState<number>()
  const { fromTreeId = '', toTreeId = '' } = useParams()

  const [ftid, fvid] = fromTreeId.split(':')
  const [ttid, tvid] = toTreeId.split(':')

  const { tree: fromTree } = useGetTreeById({ treeId: ftid, versionId: fvid })
  const { tree: toTree } = useGetTreeById({ treeId: ttid, versionId: tvid })

  const navigate = useNavigateTo()
  const params = useParams()

  React.useEffect(() => {
    Object.entries(params).forEach(([param, value]) => {
      if (!value) {
        return
      }
      switch (param) {
        case 'rf':
          setReviewFilters(value.split(',') as MappingFilterType[])
          break
        case 'ri':
          setReviewIndex(parseInt(value))
          break
      }
    })
  }, [params])

  if (!fromTree || !toTree) {
    return <Box>Loading...</Box>
  }

  return (
    <Box>
      <Box>Version Mapping</Box>
      <Box>
        <Button
          onClick={() => {
            navigate('/version_mapping')
          }}
        >
          Start Over
        </Button>
      </Box>
      <VersionMapping
        fromTree={fromTree}
        toTree={toTree}
        reviewFilters={reviewFilters}
        reviewIndex={reviewIndex}
      />
    </Box>
  )
}

export function PresentationsFixWrapper() {
  return <WithTree Wrapped={PresentationsTreeFix} />
}
